import React, { FC } from 'react';
import { ContentfulContentTypes, UniqueSellingPoints } from 'store/landing/types';
import cn from 'classnames';
import LPUniqueSellingPointText from './LPUniqueSellingPointText/LPUniqueSellingPointText';
import styles from './LandingPageUniqueSellingPoints.module.scss';

export interface LandingPageUniqueSellingPointsPros {
  uniqueSellingPoints: UniqueSellingPoints[];
}

const LandingPageUniqueSellingPoints: FC<LandingPageUniqueSellingPointsPros> = ({ uniqueSellingPoints }) => {
  return (
    <div className={cn(styles.pageHeroRibbon, styles.transparent)}>
      <div className={styles.container}>
        {uniqueSellingPoints.map((uniqueSellingPoint) => {
          return uniqueSellingPoint.contentType === ContentfulContentTypes.landingPageUniqueSellingPointText ? (
            <LPUniqueSellingPointText text={uniqueSellingPoint.text.title} key={uniqueSellingPoint.entryId} />
          ) : null;
        })}
      </div>
    </div>
  );
};

export default LandingPageUniqueSellingPoints;
